import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import { ExecMeetings } from '../components/widgets/ExecMeetings';

export default function ExecMeetingsPage() {
  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title="פגישות · דריל" />
        <main className="flex-1 overflow-y-auto p-6">
          <ExecMeetings />
        </main>
      </div>
    </div>
  );
}
